import React, { useState, FC, ReactNode, useCallback } from 'react';

import css from './PaymentMethodsWithCoupon.module.scss';
import classNames from 'classnames';
import { Checkbox } from '../../../../../../../atoms/Checkbox';
import CheckInput, { InputType } from '../../../../../../../atoms/CheckInput';

type Props = {
  paymentElementsExceptCoupon: ReactNode;
  firstTimeFreeCoupon: { publicId: string; name: string };
  isAvailableFirstTimeVoucher: boolean;
  onSelectFirstTimeFreeCoupon: () => void;
  onSelectNotCouponPayment: () => void;
};

export const PaymentMethodsWithCoupon: FC<Props> = ({
  paymentElementsExceptCoupon,
  isAvailableFirstTimeVoucher,
  firstTimeFreeCoupon,
  onSelectFirstTimeFreeCoupon,
  onSelectNotCouponPayment,
}) => {
  const [isSelectFirstTimeFreeCoupon, setIsSelectFirstTimeFreeCoupon] =
    useState<boolean>(isAvailableFirstTimeVoucher);

  const handleSelectFirstTimeFreeCoupon = useCallback(() => {
    setIsSelectFirstTimeFreeCoupon(true);
    onSelectFirstTimeFreeCoupon();
  }, [onSelectFirstTimeFreeCoupon]);

  const handleSelectNotCouponPayment = useCallback(() => {
    setIsSelectFirstTimeFreeCoupon(false);
    onSelectNotCouponPayment();
  }, [onSelectNotCouponPayment]);

  return (
    <div className={css.payment_method_container}>
      <div className={css.payment_method_section}>
        <div
          className={classNames(css.radio_button_section, css.pl_18px_width, {
            [css.bg_light_green]: isSelectFirstTimeFreeCoupon,
          })}
        >
          <div className={classNames(css.mr_14)}>
            <Checkbox
              type="radio"
              name="paymentOption"
              defaultChecked={isAvailableFirstTimeVoucher}
              onChange={handleSelectFirstTimeFreeCoupon}
            />
          </div>
          <div>
            <span className={css.radio_button_text}>
              {firstTimeFreeCoupon.name}を利用する
            </span>
          </div>
        </div>
        {isSelectFirstTimeFreeCoupon && (
          <div className={classNames(css.border_bottom, css.pl_18px_width)}>
            <CheckInput
              checked={isSelectFirstTimeFreeCoupon}
              type={InputType.Radio}
              name="payment"
              value={firstTimeFreeCoupon.publicId}
              labelPosition="SpaceBetween"
            >
              初回無料
              <span className={css.first_time_voucher_price}>0円</span>
            </CheckInput>
          </div>
        )}
      </div>
      <div className={classNames(css.payment_method_section, {})}>
        <div
          className={classNames(css.radio_button_section, css.pl_18px_width, {
            [css.bg_light_green]: !isSelectFirstTimeFreeCoupon,
          })}
        >
          <div className={classNames(css.mr_14)}>
            <Checkbox
              type="radio"
              name="paymentOption"
              defaultChecked={!isAvailableFirstTimeVoucher}
              onChange={handleSelectNotCouponPayment}
            />
          </div>
          <div>
            <span className={css.radio_button_text}>通常価格で支払う</span>
          </div>
        </div>
        {!isSelectFirstTimeFreeCoupon && (
          <div className={classNames(css.border_bottom, css.pl_18px_width)}>
            {paymentElementsExceptCoupon}
          </div>
        )}
      </div>
    </div>
  );
};
